var baseURL = 'http://boyofj.3322.org:26210'; // 服务器地址
var ImgUrl = 'http://boyofj.3322.org:26210/';
var upload = 'http://boyofj.3322.org:26210/api/sys/file/upload';
var pingImgUrl = 'http://boyofj.3322.org:18888/heshunde';
var pingExcel = 'http://boyofj.3322.org:18888/heshunde/excel/';
var otherUrl = 'http://boyofj.3322.org:44444/getdemo';
let urlAddress = window.location.host
if (urlAddress == 'boyofj.3322.org:18888') {
  baseURL = 'http://boyofj.3322.org:26210';
  ImgUrl = 'http://boyofj.3322.org:26210/';
  upload = 'http://boyofj.3322.org:26210/api/sys/file/upload';
  pingImgUrl = 'http://boyofj.3322.org:18888/heshunde/';
  pingExcel = 'http://boyofj.3322.org:18888/heshunde/excel/';
  otherUrl = 'http://boyofj.3322.org:44444/getdemo';
} else if (urlAddress == 'fjhsd.boyofj.cn:26218' || urlAddress == 'fjhsd.boyofj.cn') {
  baseURL = 'https://fjhsd.boyofj.cn:443';
  ImgUrl = 'https://fjhsd.boyofj.cn:443/';
  upload = 'https://fjhsd.boyofj.cn:443/api/sys/file/upload';
  pingImgUrl = 'https://fjhsd.boyofj.cn:443/';
  pingExcel = 'https://fjhsd.boyofj.cn:443/excel/';
  otherUrl = 'http://boyofj.3322.org:44444/getdemo';
} else if (urlAddress == 'xcx.fzhsd.cn') {
  baseURL = 'https://xcx.fzhsd.cn:443';
  ImgUrl = 'https://xcx.fzhsd.cn:443/';
  upload = 'https://xcx.fzhsd.cn:443/api/sys/file/upload';
  pingImgUrl = 'https://xcx.fzhsd.cn:443/';
  pingExcel = 'https://xcx.fzhsd.cn:443/excel/';
  otherUrl = 'http://xcx.fzhsd.cn:44444/getdemo';
}else if (urlAddress == 'localhost:8080'||urlAddress == 'localhost:8081'||urlAddress == 'localhost:8082'||urlAddress == 'localhost:8083'||urlAddress == 'localhost:8084') {
  baseURL = 'http://boyofj.3322.org:26210';
  ImgUrl = 'http://boyofj.3322.org:26210/';
  upload = 'http://boyofj.3322.org:26210/api/sys/file/upload';
  pingImgUrl = 'http://boyofj.3322.org:18888/heshunde/';
  pingExcel = 'http://boyofj.3322.org:18888/heshunde/excel/';
  otherUrl = 'http://boyofj.3322.org:44444/getdemo';
} else{
  baseURL = window.location.origin;
  ImgUrl = window.location.origin+'/';
  upload = window.location.origin+'/api/sys/file/upload';
  pingImgUrl = window.location.origin;
  pingExcel = window.location.origin;
  otherUrl = 'http://127.0.0.1:44444/getcomm';
}
export default {
  baseURL, // 后台地址
  ImgUrl, // 图片地址头部
  upload, // 图片上传接口
  pingImgUrl,// 图片回显
  pingExcel,// 导出
  otherUrl,//称重
  // 请求头信息
  headers: {
    'Content-type': 'application/json'
  },
  // 设置超时时间
  timeout: 60000,
  withCredentials:true,
  // 返回数据类型
  responseType: 'json',
  mock: false // 本地静态数据
}



// WEBPACK FOOTER //
// ./src/api/config.js